import { useCallback, useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import SortCell from 'components/atoms/GefMui/SortCell';
import { getSelectedGroup } from 'features/views/contactHistory/selectors';
import { alphabetSorterCS, equalOrThreeDashes } from 'utils';

import ServicesListRow from './ServicesListRow';

export const ServicesList = () => {
	const [sort, setSort] = useState('serviceName,asc');

	const communicationGroup = useSelector(getSelectedGroup);

	const resetSort = useCallback(() => {
		setSort('serviceName,asc');
	}, []);

	useEffect(() => {
		resetSort();
	}, [communicationGroup, resetSort]);

	const handleSort = useCallback((sortValue) => {
		setSort(sortValue);
	}, []);

	if (!communicationGroup || !communicationGroup.communications || !Array.isArray(communicationGroup.communications))
		return null;

	const [name, type] = sort.split(',');

	const communications = communicationGroup.communications
		.map((com) => {
			// this mapping is only so we can sort by it
			const cancellationReason = equalOrThreeDashes(com.activityName, communicationGroup.subActivitiesBCT);
			const serviceType = equalOrThreeDashes(com.serviceName);
			return {
				...com,
				cancellationReason: `${serviceType} / ${cancellationReason}`,
			};
		})
		.sort((a, b) => alphabetSorterCS(a[name], b[name]));

	if (type === 'desc') {
		communications.reverse();
	}

	return (
		<Paper sx={{ p: 3, borderRadius: 2 }}>
			<Stack spacing={2}>
				<SectionHeader text={getLabelMessage('contactHistory:servicesListHeader')} />
				<Table size="small">
					<TableHead>
						<TableRow>
							<TableCell>
								<SortCell hasRecords sortBy="serviceName" sort={sort} onSort={handleSort}>
									{getLabelMessage('contactHistory:service')}
								</SortCell>
							</TableCell>
							<TableCell>{getLabelMessage('contactHistory:psNumber')}</TableCell>
							<TableCell>{getLabelMessage('contactHistory:product')}</TableCell>
							<TableCell>
								<SortCell hasRecords sortBy="cancellationReason" sort={sort} onSort={handleSort}>
									{getLabelMessage('contactHistory:serviceType')} /&nbsp;
									{getLabelMessage('contactHistory:cancellationReason')}
								</SortCell>
							</TableCell>
							<TableCell>
								<SortCell hasRecords sortBy="resultActivityName" sort={sort} onSort={handleSort}>
									{getLabelMessage('contactHistory:result')}
								</SortCell>
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{communications.map((communication) => (
							<TableRow key={communication.id}>
								<ServicesListRow
									communication={communication}
									subActivitiesBCT={communicationGroup.subActivitiesBCT}
									partnerId={communicationGroup.partnerId}
								/>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</Stack>
		</Paper>
	);
};

export default ServicesList;
